import type { ReactElement } from "react";
import type { HeroVariant } from "./shared/hero-variants";

import Quotes from "@homeinstead/icons/Quotes";
import { cn } from "@homeinstead/ui";
import { getHeroVariantStyles } from "./shared/hero-variants";

export const Testimony = ({
  className,
  children,
  variant = "default",
  customIcon,
}: {
  className: string;
  children: ReactElement;
  variant?: HeroVariant;
  customIcon?: ReactElement;
}) => {
  const { textColorClass } = getHeroVariantStyles(variant);

  return (
    <div className={cn(className, textColorClass)}>
      {customIcon ? (
        <div className="flex h-12 w-12 shrink-0 items-center justify-center">
          {customIcon}
        </div>
      ) : (
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white">
          <Quotes className="h-4 w-4 fill-new-beginnings-base" />
        </div>
      )}
      {children}
    </div>
  );
};
